import styled, {css} from "styled-components"

import Button from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"
import {greys, perkbox, brand} from "@irati/ui/src/global/colors"
import {TextArea} from "@irati/ui/src/FormItem"

export const MarginButton = styled(Button)`
  margin-right: 10px;
`

export const StyledTextArea = styled(TextArea)`
  width: 95%;
  textarea {
    resize: vertical;
    overflow: auto;
    min-height: 225px;
  }
`

export const CenterIcon = styled(Icon)`
  margin: auto;
`

export const IconCircle = styled.div`
  height: 30px;
  width: 30px;
  margin-right: 10px;
  border-radius: 50%;
  background-color: ${greys.light};
`

interface ContainerProps {
  width?: string
}
export const Container = styled.div<ContainerProps>`
  width: ${({width}) => width || "100%"};
  margin: 0 auto;
`

export const PreviewContainerBase = css`
  margin: 0 auto;
  background-color: ${greys.white};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    max-width: 100%;
  }
`

export const EmailPreviewContainer = styled.div`
  ${PreviewContainerBase}
  width: 90%;
  border: 1px solid ${greys.mediumLight};
  padding: 15px;
`

interface PreviewTextContainerProps {
  border?: boolean
}
export const PreviewTextContainer = styled.div<PreviewTextContainerProps>`
  ${PreviewContainerBase}
  color: ${brand.dark};
  white-space: pre-line;
  width: 80%;
  ${({border}) => (border ? `border: 2px dotted ${greys.medium}` : "none")};
  padding: 30px;
`

interface TwoColorBackgroundProps {
  color1?: string,
  color2?: string
}
export const TwoColorBackground = styled.div<TwoColorBackgroundProps>`
  padding: 15px;
  width: 100%;
  min-height: 400px;
  background: ${({color1, color2}) => `linear-gradient(180deg, ${color1 || perkbox.blue} 100px, ${color2 || greys.lightest} 101px)`};
`

const EMAIL_HEADER_HEIGHT = 70

export const EmailHeaderLogo = styled.img`
  height: 46px;
  margin: ${(EMAIL_HEADER_HEIGHT - 46) / 2}px 10px;
`

export const HeaderSeparator = styled.div`
  border-left: 1px solid lightgray;
  margin: ${(EMAIL_HEADER_HEIGHT - 16) / 2}px 10px;
  height: 16px;
`
